import { ArrowRight, Sparkles } from "lucide-react";
import { Reveal, buildWhatsAppUrl } from "./shared";

export function Pricing({ onBookClick }) {
  return (
    <section id="pricing" className="py-8 md:py-12 grain relative overflow-hidden">
      <div
        className="absolute inset-0 pointer-events-none opacity-40"
        style={{
          background:
            "radial-gradient(680px circle at 50% 0%, rgba(240,120,44,0.14), transparent 62%)",
        }}
      />
      <div className="max-w-xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="text-center">
          <Reveal>
            <p className="eyebrow">Membership</p>
          </Reveal>
          <Reveal delay={80}>
            <h2 className="font-serif text-2xl md:text-3xl leading-[1.05] tracking-tight mt-4 text-brand-ink">
              Start your journey today
            </h2>
          </Reveal>
        </div>

        <Reveal delay={140}>
          <div
            className="mt-8 bg-brand-surface border border-brand-border p-7 md:p-9 text-center relative"
            data-testid="pricing-card"
          >
            <p className="text-sm text-brand-ink2 font-sans" data-testid="pricing-original">
              Starts from
            </p>

            {/* Hero price */}
            <div className="mt-2 flex items-end justify-center gap-2">
              <span
                className="font-serif text-4xl md:text-5xl leading-none text-brand-ink tracking-tight"
                data-testid="pricing-amount"
              >
                ₹5,499
              </span>
            </div>
            <p className="mt-2 font-serif text-base md:text-lg text-brand-accent italic">
              for 3 Months
            </p>

            <div className="mt-7">
              <button
                onClick={onBookClick}
                className="btn-accent"
                data-testid="pricing-book-btn"
              >
                Book a Free Consultation
                <ArrowRight className="h-4 w-4" />
              </button>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export function PersonalTraining() {
  return (
    <section id="one-on-one" className="pb-14 md:pb-20">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div
            className="relative overflow-hidden border border-brand-accent/30 bg-brand-surfaceAlt p-6 md:p-8"
            data-testid="one-on-one-card"
          >
            <div
              className="absolute -top-16 -right-16 w-56 h-56 rounded-full pointer-events-none"
              style={{ background: "radial-gradient(circle, rgba(240,120,44,0.16), transparent 70%)" }}
            />
            <div className="relative">
              <div className="inline-flex items-center gap-2 text-brand-accent">
                <Sparkles className="h-3.5 w-3.5" />
                <span className="eyebrow">Exclusive · 1-on-1 Coaching</span>
              </div>

              <h2 className="font-serif text-lg md:text-xl leading-[1.15] tracking-tight mt-4 text-brand-ink max-w-2xl">
                Looking for More Than a Group Workout?
              </h2>

              <p className="mt-4 text-sm md:text-base text-brand-ink2 leading-relaxed font-sans max-w-2xl">
                Experience 1-on-1 personal training with undivided attention,
                customised workout plans, and coaching tailored exclusively to
                your goals, fitness level, and lifestyle.
              </p>
              <p className="mt-2 text-sm md:text-base text-brand-ink font-sans max-w-2xl">
                Contact us to explore the right plan for you.
              </p>

              <div className="mt-6">
                <a
                  href={buildWhatsAppUrl(
                    "Hi Aditya, I'm interested in 1-on-1 personal training. Can you share the right plan for me?"
                  )}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-outline !py-2.5 !px-5 text-sm"
                  data-testid="one-on-one-contact-btn"
                >
                  Contact Us
                  <ArrowRight className="h-4 w-4" />
                </a>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
